import QuestionItem from './QuestionItem'
import { IQuestionItem } from '../../types/questionnaire'

const QuestionList = ({
    questions,
    selectedQuestion,
    setSelectedQuestion,
    isMobile,
    getQuestionResponseCount,
    onQuestionSelect,
    showResponseCount = true,
  }: {
    questions: IQuestionItem[],
    selectedQuestion: number | null,
    setSelectedQuestion: (question: number | null) => void,
    isMobile: boolean,
    getQuestionResponseCount: (questionId: number) => number,
    onQuestionSelect?: (questionId: number) => void,
    showResponseCount?: boolean,
  }) => {
    return (
      <>
        {questions.map((question) => (
          <QuestionItem
            key={question.id}
            question={question}
            selectedQuestion={selectedQuestion}
            setSelectedQuestion={setSelectedQuestion}
            isMobile={isMobile}
            getQuestionResponseCount={getQuestionResponseCount}
            onQuestionSelect={onQuestionSelect}
            showResponseCount={showResponseCount}
          />
        ))}
      </>
    )
  }

export default QuestionList;
